import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchCompetitionLink } from './actions';
import Diff from 'Components/Diff';

@connect(store => ({
  links: store.competition.link,
}))
export default class CompetitionsDiff extends Component {
  componentDidMount() {
    const { dispatch, oldValue, newValue } = this.props;

    for (let i = 0; i < oldValue.length; i += 1) {
      dispatch(fetchCompetitionLink(oldValue[i]));
    }
    for (let i = 0; i < newValue.length; i += 1) {
      dispatch(fetchCompetitionLink(newValue[i]));
    }
  }

  getName(id) {
    const { links } = this.props;
    if (!links[id] || links[id].fetching) return `competition:${id}`;
    return links[id].name;
  }

  render() {
    const { oldValue, newValue } = this.props;

    const oldListWithLabel = oldValue.map(v => this.getName(v));
    const newListWithLabel = newValue.map(v => this.getName(v));

    const o = `[ ${oldListWithLabel.join(' , ')} ]`;
    const n = `[ ${newListWithLabel.join(' , ')} ]`;
    return <Diff oldValue={o} newValue={n} />;
  }
}
